<template>
  <nav>
    <div id='nav'>
      <router-link to="/"><h1 v-on:click="scrollToTop">Jun Ichiro Koyama © 2021</h1></router-link>
      <div class="nav-right-wrapper">
        <select v-model="selectedProjectType" v-on:change="sortPrj()" v-if="this.$route.name === 'Index'">
          <option value="Featured">Featured</option>
          <option value="Company">Company</option>
          <option value="Freelance">Freelance</option>
          <option value="Personal">Personal</option>
        </select>
        <button v-on:click="isHidden = !isHidden" class="btn-menu">
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="100%" height="100%" viewBox="0 0 224 104">
            <g id="koyama" stroke="white" fill="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="
                M 2 2
                L 22 2
                L 22 82
                L 2 102
                Z
              "></path>
              <path d="
                M 42 2
                L 62 2
                L 62 102
                L 42 102
                Z
              "></path>
              <path d="
                M 82 2
                L 102 2
                L 102 102
                L 82 82
                Z
              "></path>
              <path d="
                M 122 2
                L 142 2
                L 142 99
                L 162 99
                L 162 2
                L 182 22
                L 182 99
                L 202 99
                L 202 2
                L 222 2
                L 222 102
                L 122 102
                Z
              "></path>
            </g>
            <g id="jun" stroke="gray" fill="gray" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" opacity="0">
              <path d="
                M 24 2
                L 40 2
                L 40 102
                L 4 102
                L 24 82
                Z
              "></path>
              <path d="
                M 64 2
                L 80 2
                L 80 83
                L 104 102
                L 104 2
                L 120 2
                L 120 102
                L 64 102
                Z
              "></path>
              <path d="
                M 144 2
                L 200 2
                L 200 102
                L 184 102
                L 184 22
                L 160 2
                L 160 102
                L 144 102
                Z
              "></path>
            </g>
          </svg>
        </button>
      </div>
    </div>
    <transition name="top">
      <div v-if="isHidden" class='nav-wrapper'>
        <router-link to="/" @click.native="hideMenu()" class='textlink'>Projects</router-link>
        <router-link to="/about" @click.native="hideMenu()" class='textlink'>About</router-link>
        <router-link to="/blog" @click.native="hideMenu()" class='textlink'>Blog</router-link>
        <!-- <router-link to="/service" @click.native="hideMenu()" class='textlink'>Service</router-link> -->
        <a href="https://www.instagram.com/junichiroar/" class='textlink'>Instagram</a>
        <a href="https://twitter.com/junichiroar" class='textlink'>Twitter</a>
        <a href="https://www.figma.com/@junichiroar" class='textlink'>Figma</a>
        <a href="https://dribbble.com/junichirokoyama" class='textlink'>Dribbble</a>
        <a href="https://github.com/junichirokoyama" class='textlink'>GitHub</a>
        <a href="https://www.linkedin.com/in/junichirokoyama/" class='textlink'>Linkedin</a>
      </div>
    </transition>
    <div v-if="isHidden" class='overlay'></div>
  </nav>
</template>

<script>
export default {
  name: '',
  data () {
    return {
      isHidden: false,
      selectedProjectType: "Featured"
    }
  },
  methods: {
    hideMenu: function() {
      // HIDE MENU
      this.isHidden = false
      // SCROLL TO TOP
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    },
    scrollToTop: function() {
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    },
    sortPrj: function() {
      this.$store.state.sortPrj = this.selectedProjectType
    }
  }
}
</script>

<style lang="scss" scoped>

nav {
  min-height: 80px;
  @include media("<=tablet") {
    min-height: 0;
  }
}

#nav {
  padding: 0 24px;
  @include flex(between, center);
  position: fixed;
  top: 0;
  left: 0;
  width: calc(100% - 48px);
  height: 80px;
  z-index: 400;
  mix-blend-mode: difference;
  @include media("<=tablet") {
    top: auto;
    bottom: 0;
    height: 40px;
  }
}

.nav-right-wrapper {
  @include flex(center, center);
}

.nav-wrapper {
  position: fixed;
  top: 0;
  margin: 0;
  background-color: $wallpaper;
  z-index: 100;
  width: 100%;
  height: 80vh;
  @include flex(center, center);
  @include media("<=tablet") {
    height: 50vh;
    top: auto;
    bottom: 0;
    padding-top: 40px;
    padding-bottom: 60px;
  }
  > a {
    @include media("<=tablet") {
      width: 100%;
      padding: 0 24px;
      text-align: right;
    }
  }
  > a:not(:last-child) {
    margin-right: 10px;
    @include media("<=tablet") {
      margin-right: 0;
    }
  }
  @include media("<=tablet") {
    @include flex(center, center, wrap);
  }
}

h1 {
  font-size: 16px;
  font-weight: 400;
  color: white;
  @include media("<=tablet") {
    font-size: 14px;
    font-weight: 400;
  }
}

select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  -ms-appearance: none;
  font-size: 16px;
  border:none;
  outline:none;
  background-color: black;
  color: white;
  margin-right: 24px;
  cursor: pointer;
  &::after {
    content: '';
    @include icon-arrow-down;
  }
  @include media("<=tablet") {
    font-size: 14px;
    font-weight: 400;
  }
}

button {
	width: 36px;
	background: none;
  border: none;
  outline:none;
	padding: 0;
  mix-blend-mode: difference;
  cursor: pointer;
  @include flex(center, center);
  &:active {
    border: none;
  }
  @include media("<=tablet") {
    width: 28px;
  }
}

.router-link-exact-active {
  background-size: 100% 2px;
  @include media("<=tablet") {
    background-size: 0;
    opacity: 20%;
  }
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  backdrop-filter: blur(14px);
  background-color: rgba(0,0,0,.1);
  z-index: 10;
}


</style>